export default __webpack_public_path__ + "static/media/spanishOpen.343cfa67.jpg";